<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Toast from "vue-toastification";
import Vue from "vue";
import "ant-design-vue/dist/antd.css";
import "./assets/styles/style.scss";
import "vue-toastification/dist/index.css";

Vue.config.productionTip = false;
const options = {
  maxToasts: 20,
  timeout: 3000,
};

import Antd from "ant-design-vue";
Vue.use(Antd);
Vue.use(Toast, options);

import { mapState } from "vuex";
export default {
  name: "App",

  computed: {
    ...mapState({
      isAuthenticated: (state) => state.user.isAuthenticated,
    }),
  },
  watch: {
    $route: {
      handler: function (route) {
        if (route.fullPath !== "/leave-management/annual-leave") {
          localStorage.removeItem("activeTab");
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push("/login").catch((e) => {
        throw e;
      });
    } else {
      let currentPath = this.$router.history.current.path;
      if (currentPath === "/login") {
        this.$router.push("/").catch((e) => {
          throw e;
        });
      } else {
        if (this.$router.currentRoute.path !== currentPath) this.$router.push(currentPath).catch((e) => {
          throw e;
        });
      }
    }
  },
};
</script>
